"use strict";

const CenterSettingsCtrl = function (CRUDService, config) {
    var ctrl = this;

    var currentPage = 0;
    var totalPages;

    ctrl.$onInit = function() {
      CRUDService.getAll(config.urls.center, undefined, 'name,asc').then(function (data) {
        ctrl.center = data._embedded.center;
        totalPages = data.page.totalPages;
      });
    };

    ctrl.remove = function(item){
      CRUDService.remove(item._links.self.href).then(
        function(){
          ctrl.$onInit();
        });
    };

    ctrl.getNextPage = function() {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(config.urls.center, currentPage, 'name,asc').then(function (data) {
          ctrl.center = ctrl.center.concat(data._embedded.center);
        });
      }
    };
  };

CenterSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: require('./center.html'),
  controller: CenterSettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings-center/settings-center.component.js